#import "../fragments/inbox-channel-event-fragment.graphql"

query GetChannelEvents(
    $channelId: ID!
    $threadId: ID
    $after: String
    $before: String
    $first: Int
    $last: Int
) {
    channelEvents(
        channelId: $channelId
        threadId: $threadId
        after: $after
        before: $before
        first: $first
        last: $last
    ) {
        sendabilityStatus
        lastSeenTime
        isActive
        pageInfo {
            startCursor
            endCursor
            hasNextPage
        }
        edges {
            node {
                ...InboxChannelEventFragment
            }
        }
    }
}
